// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient_details_page_header_img {
  height: 40px;
  width: 40px;
  margin: 0 8px 0 54px;
}`, "",{"version":3,"sources":["webpack://./src/components/PatientDetailsPageHeader/PatientDetailsPageHeader.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,oBAAA;AACJ","sourcesContent":[".patient_details_page_header_img {\r\n    height: 40px;\r\n    width: 40px;\r\n    margin: 0 8px 0 54px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
